import { useSelector } from "react-redux";

export function useExperiment(key) {
	const flags = useSelector((state) => state.featureFlags) || {};
	return flags[key] ?? false;
}
